import { render, staticRenderFns } from "./ManagePayrollAssignments.vue?vue&type=template&id=ab12c6f6"
import script from "./ManagePayrollAssignments.vue?vue&type=script&lang=js"
export * from "./ManagePayrollAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports